<template>
  <div class="currency-content" v-if="multiCurrencyEnabled && currencyList && currencyList.length">
    <el-dropdown trigger="click">
      <span class="currency-select">
        <span class="currency-current">{{ displayLabel }}</span>
        <i class="el-icon-caret-bottom"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="c in currencyList" :key="c.currencyCode">
          <div class="currency-item" @click="changeCurrency(c.currencyCode)">
            <span>{{ c.currencySymbol }} {{ c.currencyCode }} - {{ c.currencyName }}</span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { saveCurrencyPreference } from "@/api/currency";

export default {
  name: "EsCurrency",
  computed: {
    ...mapGetters(["currencyList", "currentCurrency", "currentCurrencyCode", "isLogin"]),
    multiCurrencyEnabled() {
      return localStorage.getItem('shop_multiCurrencyEnabled') !== 'false';
    },
    displayLabel() {
      const c = this.currentCurrency;
      return c ? `${c.currencySymbol} ${c.currencyCode}` : this.currentCurrencyCode || "";
    },
  },
  created() {
    if (!this.currencyList || this.currencyList.length === 0) {
      this.$store.dispatch("loadCurrencies");
    }
  },
  methods: {
    changeCurrency(code) {
      if (code === this.currentCurrencyCode) return;
      this.$store.commit("SETCURRENCY", code);
      if (this.isLogin) {
        const userInfo = this.$store.getters.userInfo;
        if (userInfo && userInfo.id) {
          this.$store.commit("SETUSERINFO", { ...userInfo, currencyCode: code });
        }
        saveCurrencyPreference(code).catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss">
.currency-content {
  .el-dropdown {
    margin-left: 26px;
    margin-top: 3px;
  }
  .currency-select {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    color: var(--color-grey);
    i {
      margin-left: 5px;
    }
  }
}
.currency-item {
  display: flex;
  align-items: center;
}
</style>
